import { render, staticRenderFns } from "./AnnotationSimpleDetails.vue?vue&type=template&id=afd4eeda&scoped=true"
import script from "./AnnotationSimpleDetails.vue?vue&type=script&lang=js"
export * from "./AnnotationSimpleDetails.vue?vue&type=script&lang=js"
import style0 from "./AnnotationSimpleDetails.vue?vue&type=style&index=0&id=afd4eeda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd4eeda",
  null
  
)

export default component.exports